import { Brand } from "../configurations/index.js";
import {
  AlbertaMigrationCountry,
  AlbertaMigrationState
} from "../constants/index.js";
import { PageContextUtils } from "./pageContextUtils.js";

export class AlbertaMigrationUtils {
  static isAlbertaPlayer = () => {
    const { country, state } = PageContextUtils.getGlobalizationData() || {};
    const { brandId } = PageContextUtils.getBrandData() || {};

    return (
      brandId === Brand.Sport_Com &&
      country?.toLowerCase() === AlbertaMigrationCountry &&
      state?.toLowerCase() === AlbertaMigrationState
    );
  };
}
